export const GET_OVERVIEW_DATA = "GET_OVERVIEW_DATA";
export const STAT_OFFERS_LAST14DAYS = "STAT_OFFERS_LAST14DAYS";
export const STAT_OFFERS_YESTERDAY = "STAT_OFFERS_YESTERDAY";
export const STAT_OFFERS_TODAY = "STAT_OFFERS_TODAY";
export const GET_TODAY_OFFERS_DATA = "GET_TODAY_OFFERS_DATA";
export const GET_TODAY_OFFERS_DATA_SUCCESS = "GET_TODAY_OFFERS_DATA_SUCCESS";
export const GET_WEEKLY_OFFERS_DATA = "GET_WEEKLY_OFFERS_DATA";
export const GET_WEEKLY_OFFERS_DATA_SUCCESS = "GET_WEEKLY_OFFERS_DATA_SUCCESS";
export const GET_DATA_FAIL = "GET_DATA_FAIL";
export const CREATE_PRODUCT = "CREATE_PRODUCT";
export const CREATE_PRODUCT_SUCCESS = "CREATE_PRODUCT_SUCCESS";
export const CREATE_PRODUCT_FAIL = "CREATE_PRODUCT_FAIL";
export const EDIT_PRODUCT = "EDIT_PRODUCT";
export const EDIT_PRODUCT_SUCCESS = "EDIT_PRODUCT_SUCCESS";
export const EDIT_PRODUCT_FAIL = "EDIT_PRODUCT_FAIL";
export const GET_SHOPS = "GET_SHOPS";
export const CREATE_SHOP = "CREATE_SHOP";
export const CREATE_SHOP_ERROR = "CREATE_SHOP_ERROR";
export const GET_SHOPS_SUCCESS = "GET_SHOPS_SUCCESS";
export const GET_SHOP_DATA = "GET_SHOP_DATA";
export const GET_PRODUCTS = "GET_PRODUCTS";
export const GET_PRODUCTS_SUCCESS = "GET_PRODUCTS_SUCCESS";
export const SHOP_PER_PAGE = 14;
export const PRODUCT_PER_PAGE = 14;
export const GET_SHOP_PRODUCTS = "GET_SHOP_PRODUCTS";
export const GET_SHOP_PRODUCTS_FAIL = "GET_SHOP_PRODUCTS_FAIL";
export const GET_SHOP_PRODUCTS_SUCCESS = "GET_SHOP_PRODUCTS_SUCCESS";
export const GET_SHOP_INITIAL_PRODUCTS_SUCCESS = "GET_SHOP_PRODUCTS_SUCCESS";

export const IMAGE_UPLOAD = "IMAGE_UPLOAD";
export const IMAGE_UPLOADED = "IMAGE_UPLOADED";
export const UPLOAD_FAILED = "UPLOAD_FAILED";

export const GET_SHOP_DETAILS = "GET_SHOP_DETAILS";
export const GET_SHOP_DETAILS_SUCCESS = "GET_SHOP_DETAILS_SUCCESS";
export const GET_SHOP_DETAIL_FAIL = "GET_SHOP_DETAIL_FAIL";

export const GET_ALL_PRODUCTS = "GET_ALL_PRODUCTS";
export const GET_ALL_INITIAL_PRODUCTS = "GET_ALL_INITIAL_PRODUCTS";
export const GET_ALL_PRODUCTS_SUCCESS = "GET_ALL_PRODUCTS_SUCCESS";
export const GET_ALL_PRODUCTS_FAIL = "GET_ALL_PRODUCTS_FAIL";

export const GET_SINGLE_PRODUCT = "GET_SINGLE_PRODUCT";
export const GET_SINGLE_PRODUCT_SUCCESS = "GET_SINGLE_PRODUCT_SUCCESS";
export const GET_SINGLE_PRODUCT_FAIL = "GET_SINGLE_PRODUCT_FAIL";

export const GET_SHOP_OVERVIEW = "GET_SHOP_OVERVIEW";
export const GET_SHOP_OVERVIEW_SUCCESS = "GET_SHOP_OVERVIEW_SUCCESS";
export const GET_SHOP_OVERVIEW_FAIL = "GET_SHOP_OVERVIEW_FAIL";

///////////

export const GET_OVERVIEW_NUMBERS = 'GET_OVERVIEW_NUMBERS';
export const GET_OVERVIEW_NUMBERS_SUCCESS = 'GET_OVERVIEW_NUMBERS_SUCCESS';
export const GET_PRODUCTS_LISTED_STAT = 'GET_PRODUCTS_LISTED_STAT';
export const GET_PRODUCTS_LISTED_STAT_SUCCESS = 'GET_PRODUCTS_LISTED_STAT_SUCCESS';
export const GET_OFFERS_SENT_STAT = 'GET_OFFERS_SENT_STAT';
export const GET_OFFERS_SENT_STAT_SUCCESS = 'GET_OFFERS_SENT_STAT_SUCCESS';
export const GET_PRODUCT_VALUE_STAT = 'GET_PRODUCT_VALUE_STAT';
export const GET_PRODUCT_VALUE_STAT_SUCCESS = 'GET_PRODUCT_VALUE_STAT_SUCCESS';
export const GET_OFFER_AMOUNT_STAT = 'GET_OFFER_AMOUNT_STAT';
export const GET_OFFER_AMOUNT_STAT_SUCCESS = 'GET_OFFER_AMOUNT_STAT_SUCCESS';


export const GET_OFFER_STATUS_STAT = 'GET_OFFER_STATUS_STAT';
export const GET_OFFER_STATUS_STAT_SUCCESS = 'GET_OFFER_STATUS_STAT_SUCCESS';




//////////

export const GET_CUSTOMER_NUMBERS = 'GET_CUSTOMER_NUMBERS';
export const GET_CUSTOMER_NUMBERS_SUCCESS = 'GET_CUSTOMER_NUMBERS_SUCCESS';

